<template>
  <v-app>
    <!-- home nav drawer -->
    <v-navigation-drawer v-model="drawer" fixed clipped app>
      <v-list dense>
        <template>
          <!-- INSPECTIONS -->
          <v-list-tile @click="$router.push('/inspection/templates')" v-if="HasAccess('INSPECTION_MANAGEMENT', 'VIEW')">
            <v-list-tile-action>
              <v-icon>toll</v-icon>
            </v-list-tile-action>
            <v-list-tile-title>Inspections</v-list-tile-title>
          </v-list-tile>
          <v-divider></v-divider>

          <!-- OPS MANAGER GROUP -->
          <v-list-group prepend-icon="group_work" v-if="HasAccess('OPS_MANAGER_ALLOCATION_MANAGEMENT', 'VIEW')">
            <v-list-tile slot="activator">
              <v-list-tile-title>Ops Managers</v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="$router.push(`/ops-manager/assessment/templates`)">
              <v-list-tile-title>Assessment Templates</v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="$router.push('/ops-manager/class-types')">
              <v-list-tile-title>Class Types</v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="$router.push('/ops-manager/allocation')">
              <v-list-tile-title>Ops-Manager Allocations</v-list-tile-title>
            </v-list-tile>
          </v-list-group>
          <v-divider></v-divider>
          <!-- CLASS TYPES -->
          <!-- <v-list-tile @click="$router.push('/class-types')">
            <v-list-tile-action>
              <v-icon>class</v-icon>
            </v-list-tile-action>
            <v-list-tile-title>Class Types</v-list-tile-title>
          </v-list-tile>
          <v-divider></v-divider>

          <v-list-tile @click="$router.push('/ops-manager/allocation')"
            v-if="HasAccess('INSPECTION_MANAGEMENT', 'VIEW')">
            <v-list-tile-action>
              <v-icon>group_work</v-icon>
            </v-list-tile-action>
            <v-list-tile-title>Ops-Manager Allocations</v-list-tile-title>
          </v-list-tile>
          <v-divider></v-divider> -->
          <!-- USERS -->
          <v-list-group prepend-icon="verified_user" v-if="HasAccess('USER_MANAGEMENT', 'VIEW')">
            <v-list-tile slot="activator">
              <v-list-tile-title>Users</v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="$router.push('/users/dashboard')">
              <v-list-tile-title>Users</v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="$router.push('/roles/dashboard')">
              <v-list-tile-title>User Roles</v-list-tile-title>
            </v-list-tile>
          </v-list-group>
          <v-divider></v-divider>

          <!-- CUSTOMERS -->
          <v-list-group prepend-icon="people" v-if="HasAccess('CUSTOMER_MANAGEMENT', 'VIEW')">
            <v-list-tile slot="activator">
              <v-list-tile-title>Customers</v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="$router.push('/customers/dashboard')">
              <v-list-tile-title>Customers</v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="$router.push('/customer-user/allocation')">
              <v-list-tile-title>Customer-User Allocation</v-list-tile-title>
            </v-list-tile>
          </v-list-group>
          <v-divider></v-divider>

          <!-- REPORTS -->
          <!-- <v-list-tile @click="$router.push('/report-dashboard')" >
            <v-list-tile-action>
              <v-icon>dashboard</v-icon>
            </v-list-tile-action>
            <v-list-tile-title>Report Dashboard</v-list-tile-title>
          </v-list-tile>
          <v-divider></v-divider> -->
          <v-list-group prepend-icon="timeline" v-if="HasAccess('REPORT_DASHBOARD', 'VIEW')">
            <v-list-tile slot="activator">
              <v-list-tile-title>Reports</v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="$router.push('/report-summary')">
              <v-list-tile-title>Report Summary</v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="$router.push('/report-dashboard')">
              <v-list-tile-title>Detailed Report</v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="$router.push('/report/customer-detail')">
              <v-list-tile-title>Customer Detail</v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="$router.push('/report/supervisor-tasks')">
              <v-list-tile-title>Supervisor Tasks</v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="$router.push('/report/ops-manager-tasks')">
              <v-list-tile-title>Ops Manager Tasks</v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="$router.push('/report/ops-manager-visits')">
              <v-list-tile-title>Ops Manager Visits</v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="$router.push('/report/customer-tasks')">
              <v-list-tile-title>Customer Tasks</v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="$router.push('/report/meeting-tasks')">
              <v-list-tile-title>Meeting Tasks</v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="$router.push('/report/supplier-evaluations')">
              <v-list-tile-title>Supplier Evaluations</v-list-tile-title>
            </v-list-tile>
          </v-list-group>
          <v-divider></v-divider>
        </template>
      </v-list>
    </v-navigation-drawer>
    <!-- <v-spacer></v-spacer> -->
    <v-toolbar dense color="primary" app clipped-left>
      <v-toolbar-side-icon @click="drawer = !drawer"></v-toolbar-side-icon>
      <span class="title ml-3 mr-5">SuburbanServ</span>
      <v-spacer></v-spacer>
      <NotificationMenuList></NotificationMenuList>
      <!-- <TaskMenuList v-if="HasAccess('USER_TASKS', 'VIEW')"></TaskMenuList> -->
      <AccountMenuList></AccountMenuList>
    </v-toolbar>
    <v-content>
      <router-view />
    </v-content>

    <v-footer app inset fixed>
      <v-spacer></v-spacer>
      <div class="hidden-sm-and-down">Powered by DevInspire (Pty) Ltd. &copy; {{ new Date().getFullYear() }}</div>
    </v-footer>
  </v-app>
</template>

<script>
import JWT from "jsonwebtoken";
import WebSocketIndicator from "@/components/common/sockets/websocket-indicator";
import LicensingIndicator from "@/components/common/licensing/licensing-indicator";
import TaskMenuList from "@/components/common/tasks/task-list-menu";
import NotificationMenuList from "@/components/common/notifications/notification-list-menu";
import AccountMenuList from "@/components/common/account/account-list-menu";

export default {
  components: {
    WebSocketIndicator,
    LicensingIndicator,
    TaskMenuList,
    NotificationMenuList,
    AccountMenuList
  },
  data() {
    let self = this;
    return {
      drawer: null,
      items: []
    };
  },
  mounted() {
    let self = this;
  },
  methods: {
    routeTo(item) {
      let self = this;
      self.$router.push(item.route);
    },
    logout() {
      let self = this;
      self.$router.push("/login");
    }
  },
  props: {
    source: String
  }
};
</script>

<style></style>